<template>
  <div>
    <multiselect
        v-if="options && options.length>0 && multiple"
        :label="label"
        v-model="selectedOption"
        :options="options"
        :multiple="multiple"
        @select="onOptionSelect"
        trackBy="id"
        :max="max||1"
    >
      <template slot="selection" slot-scope="{ values, search, isOpen }">
        <span class="multiselect__single" v-if="values.length &&  !isOpen">
          {{ values.length }} options selected
        </span>
      </template>
    </multiselect>
    <multiselect
        v-if="options && options.length>0 && !multiple"
        :label="label"
        v-model="selectedOption"
        :options="options"
        :multiple="false"
        @select="onOptionSelect"
        trackBy="id"
    >
    </multiselect>


    <input type="hidden" :value="value? JSON.stringify(value): ''">

  </div>

</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "Select",
  components: {Multiselect},
  data() {
    return {
      selectedOption: JSON.parse(JSON.stringify(this.value || ''))
    }
  },
  props: ['label', 'value', 'options', "selectedObjectKey", 'multiple', 'onSelect', 'max'],
  mounted() {

  },
  updated() {
    if(this.value){
      // this.selectedOption = JSON.parse(JSON.stringify(this.value))
    }
  },
  methods: {
    onOptionSelect(selectedOption) {
      this.$emit('onSelect', selectedOption)
    }
  },
  watch: {
    selectedOption(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal){
      this.selectedOption = newVal;
    }
  }
}
</script>

<style lang="scss">
@import "src/style/_vars.scss";

.multiselect__option--highlight {
  background: $primary !important;
  outline: none;
  color: white;
}

.multiselect__option--highlight:after {
  content: attr(data-select);
  background: $primary !important;
  color: white;
}

.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
  font-weight: bold;
}

.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}

.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}

.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  background: #ededed;
  color: #a6a6a6;
}

.multiselect__option--disabled {
  background: #ededed !important;
  color: #a6a6a6 !important;
  cursor: text;
  pointer-events: none;
}

.multiselect__option--group {
  background: #ededed;
  color: #35495e;
}

.multiselect__option--group.multiselect__option--highlight {
  background: #35495e;
  color: #fff;
}

.multiselect__option--group.multiselect__option--highlight:after {
  background: #35495e;
}

.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede;
}

.multiselect__option--group-selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}

.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}

.multiselect--above .multiselect__content-wrapper {
  width: 94%;
}
</style>
